export default {
  screen_log: {
      id: "Id",
      code: "Code",
      name: "Name",
      description: "Description",
      active: "Active",
      createdAt: "Created At",
      updatedAt: "Updated At",
      create: "Create New Screen Log",
      update: "Update Screen Log",
      title: "Choose Screens to Log",
      caption: "Screen Log Management",
      
    }
}